import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  CashTransactionLiteModel,
  CashTransactionModel,
  getCashTransactionInput,
  getCashTransactionsInput,
} from './model';

export function useGetCashTransactions(
  input?: getCashTransactionsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<CashTransactionLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<CashTransactionLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getCashTransactions', input?.params],
      () =>
        QueryFetchFunction({
          url: `cash-transactions`,
          params: input?.params,
        }),
      options,
    ),
    CashTransactionLiteModel,
  );
}

export function useGetCashTransaction(
  input?: getCashTransactionInput,
  options?: UseQueryOptions<ApiResult<CashTransactionModel>, ApiError>,
): UseQueryResult<ApiResult<CashTransactionModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getCashTransaction', input?.id],
      () =>
        QueryFetchFunction({
          url: `cash-transactions/${input?.id}`,
        }),
      options,
    ),
    CashTransactionModel,
  );
}

export function getCashTransactionsKey(input?: getCashTransactionsInput) {
  return ['getCashTransactions', input?.params];
}

export function getCashTransactionKey(input?: getCashTransactionInput) {
  return ['getCashTransaction', input?.id];
}
